export default __webpack_public_path__ + "static/media/echo-intro.514af561.mp3";